<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(0.267009, 0, 0, -0.255464, -17.584869, 505.109283)">
    <path
      d="M775 1964 c-325 -72 -581 -312 -681 -639 -25 -82 -28 -105 -28 -250 -1 -137 3 -171 22 -239 44 -152 123 -292 221 -394 34 -34 48 -42 78 -42 33 0 46 9 135 98 89 89 98 102 98 136 0 50 -36 86 -85 86 -29 0 -45 -9 -84 -45 -45 -42 -49 -44 -64 -27 -48 54 -127 246 -127 308 0 22 4 24 55 24 60 0 109 19 119 45 14 37 6 86 -19 110 -21 22 -33 25 -90 25 -62 0 -65 1 -65 24 0 59 74 243 125 310 14 18 17 17 64 -27 61 -58 98 -62 142 -18 46 46 36 103 -30 165 l-31 30 28 18 c78 54 186 99 293 122 27 6 27 6 31 -64 5 -87 26 -115 89 -115 63 0 89 36 89 121 l0 64 28 -6 c175 -38 298 -108 414 -233 72 -78 136 -191 163 -286 21 -75 51 -105 106 -105 90 0 111 75 61 218 -46 129 -107 226 -207 327 -128 130 -252 204 -420 251 -86 24 -336 29 -430 8z"
    />
    <path
      d="M1295 1508 c-11 -7 -83 -62 -160 -124 -131 -105 -143 -112 -193 -116 -155 -15 -227 -219 -119 -337 56 -60 165 -78 245 -40 55 27 98 91 107 162 7 46 18 64 109 176 55 69 109 136 118 150 27 39 23 78 -11 112 -31 30 -63 36 -96 17z"
    />
    <path
      d="M1666 991 c-126 -22 -151 -30 -167 -50 -31 -39 -23 -78 29 -134 l26 -28 -152 -152 -152 -152 -108 108 c-105 104 -108 107 -152 107 l-45 0 -268 -268 c-255 -256 -267 -270 -267 -306 0 -57 43 -96 106 -96 l48 0 213 212 213 213 98 -97 c107 -105 125 -118 173 -118 29 0 55 22 236 202 l203 202 27 -26 c58 -53 98 -61 137 -25 21 19 28 42 50 179 31 189 32 212 6 238 -26 26 -66 25 -254 -9z"
    />
  </g>
</template>
